import React from 'react';
import { NavLink, Outlet, Navigate, useLocation } from 'react-router-dom';
import { usePanelAccess } from '../../context/PanelAccessContext';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../core/store/store';
import {
  canPanelModeratePlayers,
  canPanelAdminTier,
  canPanelManagePremium,
} from '../../panelAccess/panelRoleAccess';

type Tab = { to: string; label: string; can: boolean };

const PanelJoueursPage: React.FC = () => {
  const { currentUser } = useSelector((state: RootState) => state.user);
  const { hasAccessToSection, loading } = usePanelAccess();
  const location = useLocation();
  const roleId = currentUser?.roles_id ?? 0;

  if (loading || !currentUser) return null;

  const tabs: Tab[] = [
    {
      to: '/panel/joueurs/liste',
      label: 'Liste & comptes',
      can: hasAccessToSection('salon_joueurs') || canPanelModeratePlayers(roleId),
    },
    {
      to: '/panel/joueurs/fiches',
      label: 'Fiches détaillées',
      can: hasAccessToSection('admin') || canPanelAdminTier(roleId),
    },
    {
      to: '/panel/joueurs/premium',
      label: 'Statut premium',
      can: hasAccessToSection('player_premium') || canPanelManagePremium(roleId),
    },
  ];

  const visibleTabs = tabs.filter((t) => t.can);
  if (!visibleTabs.length) return <Navigate to="/panel/dashboard" replace />;

  // Redirect /panel/joueurs → first accessible tab
  if (location.pathname === '/panel/joueurs' || location.pathname === '/panel/joueurs/') {
    return <Navigate to={visibleTabs[0].to} replace />;
  }

  return (
    <div className="space-y-5 pb-12">
      <div>
        <h1 className="text-lg font-bold text-white">Joueurs</h1>
        <p className="text-xs text-slate-400 mt-0.5">Comptes, fiches, sanctions et abonnements premium.</p>
      </div>

      <div className="flex gap-1 border-b border-[#1e2d4d] pb-0">
        {visibleTabs.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            className={({ isActive }) =>
              `px-4 py-2 text-sm font-medium transition-colors border-b-2 -mb-px ${
                isActive
                  ? 'border-[#3d4fdb] text-white'
                  : 'border-transparent text-slate-400 hover:text-slate-200 hover:border-slate-600'
              }`
            }
          >
            {tab.label}
          </NavLink>
        ))}
      </div>

      <Outlet />
    </div>
  );
};

export default PanelJoueursPage;
